var _path, _rect, _path2, _path3, _polygon, _polygon2, _path4, _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 396.85 141.732",
    enableBackground: "new 0 0 396.85 141.732",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M18.521,39.343H0.594v62.61h17.832c9.482,0,16.329-2.237,22.339-7.228c7.142-5.91,11.366-14.819,11.366-24.034C52.133,52.216,38.327,39.343,18.521,39.343z M32.788,86.377c-3.838,3.465-8.821,4.976-16.712,4.976h-3.277V49.952h3.277c7.891,0,12.679,1.411,16.712,5.063c4.224,3.76,6.764,9.589,6.764,15.585C39.552,76.612,37.012,82.618,32.788,86.377z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.752,
    y: 39.343,
    fill: "#231F20",
    width: 12.213,
    height: 62.61
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M99.827,63.37c-7.328-2.711-9.48-4.5-9.48-7.882c0-3.945,3.834-6.94,9.097-6.94c3.66,0,6.666,1.503,9.848,5.07l6.39-8.367c-5.251-4.594-11.534-6.942-18.398-6.942c-11.078,0-19.528,7.693-19.528,17.94c0,8.626,3.934,13.042,15.404,17.169c4.782,1.686,7.215,2.809,8.443,3.565c2.44,1.593,3.662,3.85,3.662,6.478c0,5.073-4.033,8.831-9.482,8.831c-5.825,0-10.517-2.913-13.328-8.35l-7.889,7.598c5.627,8.259,12.384,11.92,21.677,11.92c12.691,0,21.594-8.438,21.594-20.558C117.835,72.954,113.72,68.45,99.827,63.37z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M121.689,70.691c0,18.403,14.452,32.673,33.048,32.673c5.258,0,9.76-1.034,15.312-3.648V85.34c-4.883,4.887-9.207,6.857-14.743,6.857c-12.3,0-21.029-8.918-21.029-21.597c0-12.02,9.006-21.504,20.462-21.504c5.825,0,10.234,2.079,15.312,7.045v-14.37c-5.361-2.72-9.768-3.846-15.024-3.846C136.521,37.928,121.689,52.488,121.689,70.691z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231F20",
    points: "266.88,81.398 250.183,39.343 236.841,39.343 263.413,103.56 269.984,103.56 297.032,39.343 283.793,39.343 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231F20",
    points: "302.554,101.953 337.189,101.953 337.189,91.355 314.757,91.355 314.757,74.455 336.362,74.455 336.362,63.849 314.757,63.849 314.757,49.952 337.189,49.952 337.189,39.343 302.554,39.343 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M385.543,57.827c0-11.722-8.074-18.484-22.158-18.484h-18.108v62.61h12.198V76.802h1.593l16.903,25.152h15.019l-19.709-26.378C380.478,73.706,385.543,67.414,385.543,57.827z M361.043,68.168h-3.567V49.205h3.76c7.606,0,11.741,3.187,11.741,9.28C372.977,64.78,368.843,68.168,361.043,68.168z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MarkingBase_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.3917,
    y1: 44.1731,
    x2: 201.33,
    y2: 80.2807,
    gradientTransform: "matrix(1 0 0 -1 0 141.7323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F89F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    style: {
      stopColor: "#F79A23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    style: {
      stopColor: "#F78E22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    style: {
      stopColor: "#F68721"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    style: {
      stopColor: "#F48220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F27623"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_1_)",
    cx: 207.343,
    cy: 70.866,
    r: 33.307
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.7487,
    y1: 44.664,
    x2: 187.0436,
    y2: 110.5426,
    gradientTransform: "matrix(1 0 0 -1 0 141.7323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F68721",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    style: {
      stopColor: "#E27027",
      stopOpacity: 0.2704
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    style: {
      stopColor: "#D4612C",
      stopOpacity: 0.5299
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    style: {
      stopColor: "#D15D2D",
      stopOpacity: 0.74
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.65,
    fill: "url(#SVGID_2_)",
    enableBackground: "new    ",
    cx: 207.343,
    cy: 70.866,
    r: 33.307
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Registered_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M393.339,41.697c0-1.098-0.756-1.698-2.084-1.698h-1.767v5.503h1.313v-2.135l1.54,2.135h1.603l-1.81-2.269C392.912,43.025,393.339,42.461,393.339,41.697z M391.024,42.449h-0.222V41.01h0.236c0.649,0,0.988,0.234,0.988,0.708C392.026,42.203,391.683,42.449,391.024,42.449z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M391.521,37.944c-2.672,0-4.793,2.132-4.793,4.797c0,2.664,2.145,4.799,4.793,4.799c2.603,0,4.736-2.159,4.736-4.799C396.257,40.112,394.123,37.944,391.521,37.944z M391.5,46.682c-2.103,0-3.823-1.75-3.823-3.934c0-2.191,1.698-3.94,3.823-3.94c2.093,0,3.799,1.789,3.799,3.94C395.299,44.913,393.595,46.682,391.5,46.682z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.1b3cdec6.svg";
export { ForwardRef as ReactComponent };